<!--
 * @Author:  xuwei
 * @Date: 2020-12-28 16:51:26
 * @LastEditTime: 2021-02-02 14:57:14
 * @LastEditors: Please set LastEditors
 * @Description: 优惠券
 * @FilePath: /goupu/src/divs/ coupon.vue
-->
<template>
  <div class="coupon-container">
    <Nav :name="navName" :isBack="true"></Nav>
    <div class="coupon-tab row cen-center">
      <div
        class="tab-wrap flex1 row cen-center"
        :class="{ 'tab-active-color': activeTab == item.id }"
        v-for="(item, index) in tabList"
        :key="index"
      >
        <span @click="handlerTab(item.id)" class="tab-item">{{ item.name }}</span>
      </div>
    </div>
   
    <!-- <div class='coupon-list-wrap'></div> -->
    <div class="scroll-list-wrap" >
      <cube-scroll
        ref="scroll"
        :data="couponList"
        :options="options"
        @pulling-up="onPullingUp"
      >
      <div class="exchange-box">
        <div class="w100 h100 row cen-start exchange">
          <input class="exchange-input" :trim='true' placeholder="请输入兑换码" :clearable='false' placeholder-style="color: #9496AC;" v-model="exchangeCode" />
          <div class="exchange-btn row cen-center" :class="[!exchangeCode?'no-val':'val']" @click='exchange'>兑换</div>
          <span v-if="exchangeCode" class="code-close" @click="exchangeCode = ''"></span>
        </div>
      </div>
        <div v-if="couponList.length > 0">
          <div
            class="my-coupon-list"
            v-for="(item,index) in couponList"
            :key="index"
            :class="[activeTab !== 1?'use-list':'']"
          >
            <div class="row list-row">
              <div class="coupon-left sawtooth span-center">
                <div
                  class="discount-ammount row cen-center"
                  v-if="item.couponType == 1 || item.couponType == 2"
                >
                  <div class="row end-center">
                    <span class="ft15 cost">¥</span>
                    <span class="reduceCost">{{ item.couponAmount }}</span>
                  </div>
                </div>
                <div v-if="item.couponType == 2" class="leastCost row cen-center">
                直减券
              </div>
              <div v-else class="leastCost row cen-center">
                满<span>{{ item.smallAmount }}</span
                >元可用
              </div>
              </div>
              <div class="coupon-center">
                <div class="coupon-title ft16">{{ item.title }}</div>
                <div class="ft12 e-time">
                  <span>有效期至</span>
                  <span>{{ item.failureDate }}</span>
                </div>
                <div class="use-btn-wrap row cen-end">
                  <img
                    v-if="item.couponStatus == 4"
                    class="status-img"
                    src="https://file.40017.cn/internalcar/driver/images/H5App/expired-img.png"
                  >
                  <img
                    v-if="item.couponStatus == 3"
                    class="status-img"
                    src="https://file.40017.cn/internalcar/driver/images/H5App/use-img.png"
                  >
                  <div
                    v-if="item.couponStatus == 1"
                    class="use-btn row cen-center"
                    @click="useCoupon()"
                  >
                    立即使用
                  </div>
                </div>
                <div
                  class="use-rule row cen-space"
                  @click="lookRule(index)"
                >
                  <div>使用规则</div>
                  <img
                    v-if="(index===activeIndex)&&isShow "
                    class="up-icon"
                    src="https://file.40017.cn/internalcar/driver/images/H5App/up-icon.png"
                  >
                  <img
                    v-if="!((index===activeIndex)&&isShow) "
                    class="up-icon"
                    src="https://file.40017.cn/internalcar/driver/images/H5App/down-icon.png"
                  >
                </div>
              </div>
            </div>
            <!-- 描述 -->
            <div
              class="ft10 coupon-explain"
              v-if="(index===activeIndex)&&isShow ">
              <div v-html="item.instructions" class="pre-code">
              </div>
            </div>
          </div>
        </div>
        <div class="no-coupon row cen-center" v-if="couponList.length == 0">
          <img src="https://file.40017.cn/internalcar/driver/images/H5App/no-coupon-img.png" class="no-coupon-img">
          <span class="no-text">暂无优惠券</span>
        </div>
      </cube-scroll>
      
    </div>
   
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import * as api from "@/api";

import eventBus from "@/store/eventbus";
import { mapState } from 'vuex';

export default {
  components: {
    Nav,
  },
  computed: {
    ...mapState(['refId'])
  },
  data() {
    return {
      appId:"wx427b15fb58bf8590",
      exchangeCode:'',
      expiredImg:"https://file.40017.cn/internalcar/driver/images/H5App/expired-img.png",
      isShow:true,
      activeTab: 1,
      activeIndex: null,
      navName: "优惠券",
      tabList: [
        {
          id: 1,
          name: "未使用",
          img:''
        },
        {
          id: 3,
          name: "已使用",
        },
        {
          id: 4,
          name: "已过期",
        },
        
      ],
      cure: 1,
      pageSize: 10,
      couponList: [],
      options: {
        // pullDownRefresh: {
        //     threshold: 90,
        //     stop: 40,
        //     txt: '刷新成功'
        // },                                // 配置下拉刷新
        pullUpLoad: {
          threshold: 0,
          txt: {
            more: "上拉加载更多",
            noMore: "没有更多数据",
          },
        }, // 配置上拉加载，若要关闭可直接 pullUpLoad：false
      },
    };
  },
  mounted() {
    // 挂载
    this.loadData();
  },
  methods: {
    getCouponList(){
      const p = {
        couponStatus:this.activeTab,
        size:this.pageSize,
        cure:this.cure
        }
      api.getCouponList(p).then(result => {
        const {code, data} = result
        if(code === 200){
          this.couponList = this.couponList.concat(data.couponList);
          if(!data.couponList.length){
            this.$refs.scroll.forceUpdate();

          }else{
             this.cure+=1
             this.options.pullUpLoad =  {
              threshold: 0,
              txt: {
                more: "上拉加载更多",
                noMore: "没有更多数据",
              },
            };
          }
        }

      })
    },
    exchange(){
      if(!this.exchangeCode) return;
      api.exchangeCoupon({
         appId: this.appId,
        disRefId:this.refId,
        exchangeCode:this.exchangeCode
      }).then(({data})=>{
          if(data.code == 200){
               eventBus.$emit("showToast", '兑换成功', "alert");

           this.handlerTab(this.activeTab)
          }else{
               eventBus.$emit("showToast", data.message, "alert");
          }

      }).catch(err=>{
          console.log('err: ', err);
           eventBus.$emit("showToast", "兑换失败", "alert");
      })
    },
    
    handlerTab(index) {
      this.activeTab = index;
      this.activeIndex = null;
      this.isShow = true;
      this.couponList = []
       this.options.pullUpLoad = false
       this.cure = 1
      this.getCouponList()
    },
    useCoupon(){
      this.$router.push({
        path:'/'
      })
    },
    lookRule(index){
      console.log(' this.isShow: ',  this.isShow);
        console.log('this.activeIndex: ', this.activeIndex);
      if ((this.activeIndex === index) && this.isShow){
        this.isShow = false
      }else{
        this.isShow = true
      }
      this.activeIndex = index

    },
    // 获取数据
    loadData() {
      this.getCouponList()
    },
    
    // 触发下拉刷新
    onPullingDown() {
      console.log("下拉刷新");
      // 模拟更新数据
      this.getCouponList()
    },
    // 触发上拉加载
    onPullingUp() {
      console.log("上拉加载");
       this.getCouponList()
    },
  },
};
</script>
<style lang="less">
 .exchange-box {
      width: 100%;
      height:44px;
      padding:0px 15px;
      margin: 20px 0  0 0;
      .exchange{
        
         width: 100%;
         overflow: hidden;
         position: relative;
      }
      .exchange-input{
        flex: 1;
        height: 100%;
        background: #FFFFFF;
        padding:0 20px ;
        color: #3D4154;
        font-size: 14px;
        border: 1px solid #D6D9ED;
        border-right:none ;
        border-radius: 4px 0 0 4px;

      &::-webkit-input-placeholder {
       color: #9496AC;
        font-size: 14px;
      }
      }
      .exchange-btn{
        flex: 0 0 70px;
        height: 100%;
        border-radius: 0 4px 4px 0;
        font-size: 14px;
        color: #FFFFFF;
      }
      .code-close{
        position: absolute;
        right:75px;
        width: 18px;
        height: 18px;
        background-image: url("https://file.40017.cn/internalcar/driver/images/H5App/icon-clear-address.png");
        background-size: 100% 100%;
      }
      .no-val{
        background: #CFD2E0;
      }
      .val{
        background-image: linear-gradient(-90deg, #FC6F53 13%, #F35860 91%);

      }
  }
.scroll-list-wrap {
  width: 100%;
  height: 100%;
  .item {
    padding: 10px 10px;
    &:nth-child(2n + 1) {
      background: #ccc;
    }
  }
  .cube-scroll-wrapper {
    // padding-bottom:20px;
  }
  .cube-pullup-wrapper {
    font-size: 16px;
  }
}
</style>
<style lang="less" scoped>
.coupon-container {
  width: 100%;
  height: 100%;
  padding-top: 88px;
  position: relative;
  // flex:auto;
  .coupon-tab {
    position: absolute;
    top: 44px;
    left: 0;
    width: 100%;
    background-color: #fff;
    .tab-wrap {
      width: 100%;
      height: 44px;
      font-size: 14px;
      color: #3d4154;
    }
  }

.no-coupon{
  margin-top: 170px;
  flex-wrap: wrap;
  text-align: center;
  .no-coupon-img{
    width: 80px;
    height: 80px;
    display:block;
    margin:0 auto;
    margin-bottom: 10px;
  }
  .no-text{
    color: #999;
    font-size: 14px;
    width: 100%;
  }
}


  .tab-active-color {
    position: relative;
  }
  .tab-active-color .tab-item {
    font-weight: bold;
  }
  .tab-active-color::before {
    content: "";
    position: absolute;
    bottom: 4px;
    left: 50%;
    width: 21px;
    height: 4px;
    /* z-index: -1; */
    border-radius: 1px;
    transform: skewX(-40deg) translateX(-50%);
    background: #f35860;
  }
  .my-coupon-list{
    padding:0 15px 15px 15px;
    position: relative;
  }
  .my-coupon-list:first-of-type{
    padding-top: 15px;
  }

.list-row{
  width: 100%;
  height: 110px;
  background: #FFFFFF;
 box-shadow: 0 2px 4px 0 rgba(189, 189, 189, 0.5);
  border-radius: 4px;
  display: flex;
  /* z-index: 1; */
  position: relative;
  top: 0;
  left: 0;
}
.coupon-left{
  width: 110px;
  height: 110px;
 
  border-right:  1px dashed #fff;
}

.use-list{
  .discount-ammount{
    background: #9EA0B4;
  }
  .leastCost{
    background: #F4F5FB;
    font-size: 12px;
    color: #9EA0B4;
  }
  .coupon-title{
    color: #9EA0B4;
  }
  .coupon-explain{
    font-size: 12px;
    color: #9EA0B4;
  }
}

.sawtooth {
    /* 相对定位，方便让before和after伪元素绝对定位偏移 */
    position: relative;
    /* 把超出div的部分隐藏起来 */
    overflow: hidden;
    border-radius: 4px 0 0 0;
}

.sawtooth:before, .sawtooth:after {
    content: ' ';
    width: 0;
    height: 90%;
    /* 绝对定位进行偏移 */
    position: absolute;
    top: 6px;
}


.sawtooth:after {
    /* 圆点型的border */
    border-left: 8px dotted white;
    /* 偏移一个半径，让圆点的一半覆盖div */
    right: -4px;
}
.discount-ammount{
  width: 110px;
  height: 85px;
  background-image: linear-gradient(136deg, #FF9C50 3%, #FF6965 62%);

}
.cost{
  font-size: 15px;
  color: #FFFFFF;
  line-height: 20px;
}
.reduceCost{
  font-size: 36px;
  color: #FFFFFF;
  line-height: 1;
}

.leastCost{
  width: 110px;
  height: 25px;
  background-image: linear-gradient(90deg, #FFCEBC 6%, #FF9C86 100%);
  border-radius: 0 0 0 4px;
  font-size: 12px;
color: #F94C2E;
}
.coupon-center{
  padding: 0 15px;
  flex:1;
}
.coupon-title{
  color: #3D4154;
  max-width: 200px;
  margin-top: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; 
}
.e-time{
  margin-top: 3px;
  color: #9496AC;
}
.use-btn-wrap{
  width: 100%;
  height: 22px;
  position: relative

}
.status-img{
  position: absolute;
  top:-54px;
  right: -15px;
  width: 63.5px;
  height: 71px;
}

.use-btn{
  width: 60px;
  height: 22px;
  background-image: linear-gradient(90deg, #FC6F53 13%, #F35860 91%);
  border-radius: 12px;
  color: #FFFFFF;
  font-size: 10px;

}
.use-rule{
  width: 100%;
  height: 24px;
  margin-top:8px;
  font-size: 10px;
  color: #9496AC; 
  border-top: 1px dashed #DBDEEC; 
}
.up-icon{
  width: 10px;
  height: 10px;
}
.coupon-explain{
  width: 100%;
  z-index: -1;
  background: #FFFFFF;
  border-radius: 4px;
  /* margin-top: 10rpx; */
  box-shadow: 0 2px 4px 0 rgba(189,189,189,0.50);
  font-size: 12px;
  color: #73758E;
  padding:10px 15px; 
  line-height: 17px;
  .pre-code{
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    *word-wrap: break-word;
    *white-space : normal ;
  }
}
}
</style>